import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';
import { MediaType } from '../slices/thumbnailSlice';

export const selectThumbnails = (state: RootState) => state.thumbnails.thumbnails;

export const selectSelectedFileNames = (state: RootState) => state.thumbnails.selectedFileNames;

// Memoized selector for images only
export const selectImageThumbnails = createSelector(
  [selectThumbnails],
  (thumbnails) => thumbnails.filter(t => t.mediaType === MediaType.IMAGE)
);

// Memoized selector for videos only
export const selectVideoThumbnails = createSelector(
  [selectThumbnails],
  (thumbnails) => thumbnails.filter(t => t.mediaType === MediaType.VIDEO)
);

// Memoized selector factory for individual thumbnail selection state
export const makeSelectIsMediaSelected = () =>
  createSelector(
    [selectSelectedFileNames, (_: RootState, fileName: string) => fileName],
    (selectedFileNames, fileName) => selectedFileNames.includes(fileName)
  );

// Get thumbnail by file name
export const makeSelectThumbnailByFileName = () =>
  createSelector(
    [selectThumbnails, (_: RootState, fileName: string) => fileName],
    (thumbnails, fileName) => thumbnails.find(t => t.name === fileName)
  );
